module.exports = __webpack_public_path__ + "static/media/5.626cad9a.png";